import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigLoaderService {
  constructor(private http: HttpClient) {}

  loadConfig(configPath: string): Observable<any> {
    return this.http.get(configPath, { responseType: 'text' }).pipe(
      map(text => this.removeCommentsAndParse(text))
    );
  }

  private removeCommentsAndParse(jsonText: string): any {
    // Remove single-line comments, but preserve // within string literals
    const withoutSingleLineComments = jsonText.replace(/("(?:[^"\\]|\\.)*")|\/\/.*$/gm, '$1');
    
    // Remove multi-line comments (/* ... */), but preserve within string literals
    const withoutMultiLineComments = withoutSingleLineComments.replace(/("(?:[^"\\]|\\.)*")|(\/\*[\s\S]*?\*\/)/g, '$1');
    
    // Remove trailing commas before closing braces/brackets
    const withoutTrailingCommas = withoutMultiLineComments.replace(/,(\s*[}\]])/g, '$1');
    
    return JSON.parse(withoutTrailingCommas);
  }
}
